module.exports = __webpack_public_path__ + "img/2.6ac32171.jpg";